import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Radio from "@mui/material/Radio";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// DigiHapi components
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import Notification from "components/DigiHapi/Notification";
import FormModal from "components/DigiHapi/FormModal";

import { IoIosPeople } from "react-icons/io";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	fetchGetEmployees,
	fetchRegisterEmployee,
	fetchDeleteEmployee,
	setEmployeeGender,
	setEmployeeEmail,
	setEmployeeFirstname,
	setEmployeeLastname,
	clearEmployeeEmail,
	addEmployeeRole,
	clearEmployeeValidate,
	validateEmployeeInputs,
	resetEmployeeData
} from "actions/employee";

import {
	ROLE_EMPLOYEE,
	ROLE_WEBMASTER,
	ROLE_ADMINISTRATOR,
	TYPE_NEIGHBORHOOD,
	ROLE_NEIGHBOR
} from "actions/types.js";

class AddEmployee extends Component {
	render() {
		const {
			isFetching,
			gender,
			firstname,
			firstnameErrorMsg,
			lastname,
			lastnameErrorMsg,
			email,
			emailState,
			emailErrorMsg,
			onClose,
			onClickAdd,
			setEmployeeGender,
			setEmployeeEmail,
			setEmployeeFirstname,
			setEmployeeLastname,
			clearEmployeeEmail,
			community
		} = this.props;

		return (
			<FormModal maxWidth="md">
				<Card>
					<MDBox
						mx={2}
						mt={-3}
						py={2}
						px={2}
						variant="gradient"
						bgColor="primary"
						borderRadius="lg"
						coloredShadow="primary"
						display="inline-block"
					>
						<MDTypography variant="h6" color="white">
							{community.communitytype === TYPE_NEIGHBORHOOD
								? "Ajout d'un voisin"
								: "Ajout d'un membre du personnel"}
						</MDTypography>
					</MDBox>
					<MDBox p={2}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={4}>
								<FormControlLabel
									control={
										<Radio
											checked={!gender || gender === "M"}
											onChange={e => setEmployeeGender(e.target.value)}
											value="M"
											name="mister"
											disabled={isFetching}
										/>
									}
									label="M."
								/>
								<FormControlLabel
									control={
										<Radio
											checked={!!gender && gender === "F"}
											onChange={e => setEmployeeGender(e.target.value)}
											value="F"
											name="miss"
											disabled={isFetching}
										/>
									}
									label="Mme"
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<MDInput
									label="Prénom *"
									id="firstname"
									fullWidth
									error={!!firstnameErrorMsg}
									helperText={firstnameErrorMsg}
									value={firstname || ""}
									onChange={e => setEmployeeFirstname(e.target.value)}
									disabled={isFetching}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<MDInput
									label="Nom *"
									id="lastname"
									fullWidth
									error={!!lastnameErrorMsg}
									helperText={lastnameErrorMsg}
									value={lastname || ""}
									onChange={e => setEmployeeLastname(e.target.value)}
									disabled={isFetching}
								/>
							</Grid>
							<Grid item xs={12}>
								<MDInput
									label="Email *"
									id="email"
									fullWidth
									type="text"
									success={emailState === "success"}
									error={emailState === "error" || !!emailErrorMsg}
									helperText={emailErrorMsg}
									value={email || ""}
									onChange={e => setEmployeeEmail(e.target.value)}
									InputProps={{
										endAdornment:
											emailState === "error" ? (
												<InputAdornment position="end">
													<IconButton
														size="small"
														color="error"
														onClick={() => clearEmployeeEmail()}
													>
														<Icon>close</Icon>
													</IconButton>
												</InputAdornment>
											) : undefined
									}}
								/>
							</Grid>
						</Grid>
					</MDBox>
					<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
						<MDButton variant="outlined" color="secondary" onClick={onClose}>
							Annuler
						</MDButton>
						<MDButton variant="gradient" color="primary" onClick={onClickAdd}>
							<Icon>person_add</Icon>
							&nbsp;Ajouter
						</MDButton>
					</MDBox>
				</Card>
			</FormModal>
		);
	}
}

class EmployeesPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null,
		component: null,
		employeeToDelete: null
	};

	componentDidMount() {
		const { fetchGetEmployees, role, community } = this.props;
		fetchGetEmployees(community._id);
		if (role) {
			this.addComponent(role);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetEmployees,
			fetchRegisterEmployee,
			gender,
			firstname,
			lastname,
			email,
			snackErrorMsg,
			snackInfoMsg,
			clearValidate,
			isValid,
			role,
			community,
			validateEmployeeInputs
		} = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				component: null
			});
			fetchGetEmployees(community._id);
			this.autoCloseMessage();
		}

		if (clearValidate && !prevProps.clearValidate) {
			validateEmployeeInputs();
		}

		if (role && !prevProps.role) {
			this.addComponent(role);
		}

		if (isValid && !prevProps.isValid) {
			fetchRegisterEmployee({
				gender,
				firstname,
				lastname,
				email,
				role,
				communityId: community._id
			});
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	onClose = () => {
		this.setState({
			component: null
		});
		this.props.resetEmployeeData();
	};

	fetchRegisterEmployee = e => {
		e.preventDefault();
		this.props.clearEmployeeValidate();
	};

	addComponent = () => {
		this.setState({
			component: (
				<ConnectedAddEmployee
					onClickAdd={this.fetchRegisterEmployee}
					onClose={this.onClose}
				/>
			)
		});
	};

	deleteEmployee = id => {
		this.props.fetchDeleteEmployee(id, this.props.community._id);
	};

	getRoundButtons = (id, lastname) => {
		return [{ color: "error", icon: "delete", onClick: this.delete }].map(
			(prop, key) => (
				<MDButton
					variant="gradient"
					size="small"
					circular
					iconOnly
					color={prop.color}
					disabled={!!this.state?.component}
					key={key}
					onClick={() => prop.onClick(id)}
				>
					<Icon>{prop.icon}</Icon>
				</MDButton>
			)
		);
	};

	getEmployees = () => {
		const { employees } = this.props;

		let employeesObj = [];

		if (employees) {
			employeesObj = employees.map(
				({ _id, email, firstname, lastname, description, role }) => {
					return {
						email,
						firstname,
						lastname,
						description,
						role,
						actions: (
							<MDBox display="flex" justifyContent="flex-end">
								{this.getRoundButtons(_id, lastname)}
							</MDBox>
						)
					};
				}
			);
		}

		return employeesObj;
	};

	delete = id => {
		this.setState({ employeeToDelete: id });
	};

	render() {
		const { color, message, component, employeeToDelete } = this.state;
		const { isFetchingList, user, community, addEmployeeRole } = this.props;

		const columns = [
			{
				Header: "Email",
				accessor: "email",
				sortable: true,
				filterable: false
			},
			{
				Header: "Prénom",
				accessor: "firstname",
				sortable: true,
				filterable: false
			},
			{
				Header: "Nom",
				accessor: "lastname",
				sortable: true,
				filterable: false
			},
			{
				Header: "Description",
				accessor: "description",
				sortable: false,
				filterable: false
			},
			{
				Header: "Actions",
				accessor: "actions",
				sortable: false,
				filterable: false
			}
		];

		if (user.role === ROLE_WEBMASTER) {
			columns.unshift({
				Header: "Rôle",
				accessor: "role",
				sortable: true,
				filterable: false
			});
		}

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<IoIosPeople size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								{community.communitytype === TYPE_NEIGHBORHOOD
									? "Voisins"
									: "Membres du personnel"}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DataTable
								data={this.getEmployees()}
								filterable
								columns={columns}
								loading={isFetchingList}
								defaultPageSize={5}
								showPaginationTop
								showPaginationBottom={false}
								previousText="Précédent"
								nextText="Suivant"
								rowsText="Lignes"
								noDataText="Aucuns membres du personnel"
								ofText="sur"
								loadingText="Chargement..."
							/>
						</MDBox>
						<MDBox
							p={2}
							display="flex"
							flexWrap="wrap"
							justifyContent="flex-end"
							gap={1}
						>
							<MDButton
								variant="gradient"
								color="primary"
								onClick={() => addEmployeeRole(ROLE_EMPLOYEE)}
								disabled={!!component}
							>
								<Icon>person_add</Icon>
								&nbsp;Ajout d'un membre du personnel
							</MDButton>
							{community.communitytype === TYPE_NEIGHBORHOOD && (
								<MDButton
									variant="gradient"
									color="primary"
									onClick={() => addEmployeeRole(ROLE_NEIGHBOR)}
									disabled={!!component}
								>
									<Icon>person_add</Icon>
									&nbsp;Ajout d'un voisin
								</MDButton>
							)}
							{user.role === ROLE_WEBMASTER && (
								<MDButton
									variant="gradient"
									color="primary"
									onClick={() => addEmployeeRole(ROLE_ADMINISTRATOR)}
									disabled={!!component}
								>
									<Icon>person_add</Icon>
									&nbsp;Ajout administrateur
								</MDButton>
							)}
						</MDBox>
					</Card>
				</Grid>
				{component}
				<ConfirmDialog
					open={!!employeeToDelete}
					message="Êtes-vous sûr de vouloir supprimer l'employé ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ employeeToDelete: null })}
					onConfirm={() => {
						this.deleteEmployee(employeeToDelete);
						this.setState({ employeeToDelete: null });
					}}
				/>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		employees,
		gender,
		firstname,
		lastname,
		email,
		role,
		snackInfoMsg,
		snackErrorMsg,
		clearValidate,
		isValid,
		firstnameErrorMsg,
		lastnameErrorMsg,
		emailState,
		emailErrorMsg
	} = state.employeeReducer;
	const { community } = state.entitiesReducer;

	return {
		isFetchingList,
		isFetching,
		employees,
		gender,
		firstname,
		lastname,
		email,
		role,
		snackInfoMsg,
		snackErrorMsg,
		clearValidate,
		isValid,
		user: state.profileReducer.user,
		firstnameErrorMsg,
		lastnameErrorMsg,
		emailState,
		emailErrorMsg,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetEmployees,
			fetchRegisterEmployee,
			fetchDeleteEmployee,
			setEmployeeGender,
			setEmployeeEmail,
			setEmployeeFirstname,
			setEmployeeLastname,
			clearEmployeeEmail,
			addEmployeeRole,
			clearEmployeeValidate,
			validateEmployeeInputs,
			resetEmployeeData
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedAddEmployee = connect(
	mapStateToProps,
	mapDispatchToProps
)(AddEmployee);

export default {
	EmployeesPage: connect(mapStateToProps, mapDispatchToProps)(EmployeesPage),
	AddEmployee: ConnectedAddEmployee
};
